module.exports = __webpack_public_path__ + "media/images/right-arrow-3790d84e94f0ef52ac6f84dd06a9f4fc.png";